@import Button from "./Button.xzor"

@code {
  id = "";
  title = "";
  dialog?: HTMLDialogElement;

  show() {
    this.dialog?.showModal();
  }

  close() {
    this.dialog?.close();
  }
}

<dialog class="xz-dialog" id="@id" data-depth="3" closedby="any" aria-labelledby="@(id + '-title')" @ref="dialog">
  <header>
    <h2 id="@(id + '-title')">@title</h2>
    <Button icon="x" label="Close" variant="ghost" size="sm" closes="@id" />
  </header>
  <div class="xz-sheet-body">@slot</div>
  @if (this.slots.actions) {
    <footer>@slot:actions</footer>
  }
</dialog>
